import List from './list'

export default function(prefix, app) {
  return app
    .useRoute(`${prefix}/list`, List)
}
